// extracted by mini-css-extract-plugin
module.exports = {"component":"AskInHouseExperts_component__ToS8n","icon":"AskInHouseExperts_icon__dYGSw","link":"AskInHouseExperts_link__MJJQl"};